import type { AutomationType } from '@playbook-technologies/common-enums';

type AutomationCopy = {
  label: string;
  description: string;
  disableConfirmation: { title: string; body: string };
};

export const AUTOMATION_COPY = {
  abandoned_cart: {
    label: 'Abandoned cart emails',
    description:
      'Automatically follow up with customers who leave checkout without completing a purchase.',
    disableConfirmation: {
      title: 'Turn off abandoned cart emails?',
      body: 'Active abandoned-cart email sequences will be stopped and cannot be resumed. Turning this automation back on will apply only to new abandoned carts.',
    },
  },
} satisfies Record<AutomationType, AutomationCopy>;

export const AUTOMATION_ORDER = [
  'abandoned_cart',
] as const satisfies readonly AutomationType[];

type AssertNever<T extends never> = T;
export type AllAutomationTypesAreOrdered = AssertNever<
  Exclude<AutomationType, (typeof AUTOMATION_ORDER)[number]>
>;
